import { render, staticRenderFns } from "./cards-modal.vue?vue&type=template&id=51bd1c5a&scoped=true&"
import script from "./cards-modal.vue?vue&type=script&lang=js&"
export * from "./cards-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bd1c5a",
  null
  
)

export default component.exports